module.exports = __webpack_public_path__ + "static/media/circle-marker-red-light.b76239d7.svg";